// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"a03059a2","732":"69e152fb","977":"43597cf7"}[chunkId] + ".chunk.js";
};